import React, { useState } from "react";
import RLookUpModal from "../../SellFactor/FactorKOL/RLookUpModal";
import "./CodeCustomer.scss";

const CodeCustomer = ({
  initialData,
  setcustomerCode,
  customerCode,
  backendData,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleCustomerSelection = (incomingData) => {
    console.log(incomingData);

    setcustomerCode({
      customerId: incomingData.na_35,
      customerName: incomingData.na_45,
    });

    setIsOpen(false); // Close the modal after selection
  };

  const displayedCustomer =
    customerCode.customerName || (backendData ? backendData.customerId : "");

  return (
    <>
      <div onClick={() => setIsOpen(true)} className={"customerCode"}>
        <label>کد مشتری</label>
        <div className="input">
          {displayedCustomer ? (
            <span style={{ color: "#000000" }}>{displayedCustomer}</span>
          ) : (
            <span style={{ color: "#B9B9B9" }}>مشتری را انتخاب کنید</span>
          )}
        </div>

        {isOpen && (
          <RLookUpModal
            id={initialData.RLookUpId}
            callBackDataHandler={handleCustomerSelection}
            modalHandler={[
              isOpen,
              (open) => setTimeout(() => setIsOpen(open), 1),
            ]}
          />
        )}
      </div>
    </>
  );
};

export default CodeCustomer;
